///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

const validFieldState = {
  isValid: true,
  validationMessage: ""
};

export const tlValidationDefaults = {
  laneCount: validFieldState,
  volume: validFieldState,
  fuelSurchargeType: validFieldState,
  fuelSurchargePeg: validFieldState,
  equipmentTypes: validFieldState,
  currencyType: validFieldState,
  internationalLanes: validFieldState,
  rxoFuel: validFieldState,
  customerFuel: validFieldState,
  customerBranchAndNetworkTimeframeStartDate: validFieldState,
  customerBranchAndNetworkTimeframeEndDate: validFieldState
};

export const ltlValidationDefaults = {
  laneCount: validFieldState,
  volume: validFieldState,
  ltlFreightClasses: validFieldState,
  palletsStackable: validFieldState,
  ltlIncumbentCarriers: validFieldState,
  ltlRateReturnFormat: validFieldState,
  requiresGuaranteedShipment: validFieldState,
  ltlAccessorials: validFieldState
};

export const imdlValidationDefaults = {
  laneCount: validFieldState,
  volume: validFieldState,
  fuelSurchargeType: validFieldState,
  fuelSurchargePeg: validFieldState,
  equipmentLengths: validFieldState,
  currencyType: validFieldState,
  rxoFuel: validFieldState,
  customerFuel: validFieldState
};

export const bidStrategyDefaults = {
  bidStrategy: validFieldState,
  shipperTenderStrategy: validFieldState,
  expectedLanesPerDay: validFieldState,
  goalLanesPerDay: validFieldState,
  acceptanceParameters: validFieldState,
  strategyNotes: validFieldState
};

export const newBidValidationDefaults = {
  bidInformation: {
    openDateUTC: validFieldState,
    closeDateUTC: validFieldState,
    additionalBidRounds: [],
    startDateUTC: validFieldState,
    endDateUTC: validFieldState,
    shipper: validFieldState,
    bidOutputFormat: validFieldState,
    mainSalesRep: validFieldState,
    rfqName: validFieldState,
    marginExpectationPercentage: validFieldState,
    totalRounds: validFieldState,
    bidType: validFieldState,
    salesforceOpportunityId: validFieldState,
    previousSalesforceOpportunityId: validFieldState,
    locationCode: validFieldState,
    foShipperCode: validFieldState,
    awardDateUTC: validFieldState
  },
  modeInformation: {
    tl: tlValidationDefaults,
    ltl: ltlValidationDefaults,
    imdl: imdlValidationDefaults
  },
  bidStrategy: {
    tl: {
      ...bidStrategyDefaults,
      strategicQuantile: validFieldState
    },
    ltl: bidStrategyDefaults,
    imdl: bidStrategyDefaults
  }
};

export default newBidValidationDefaults;
